import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (open) => ({
  borderRadius: 1,
  borderColor: (p) => (open ? p.palette.primary[400] : p.palette.grey[300]),
  backgroundColor: (p) => p.palette.common.white,
});

export const actions: SxStyle = {
  flexDirection: 'row-reverse',
  placeContent: 'end',
  borderTopColor: (p) => `${p.palette.grey[300]} !important`,
};
